'use strict';

angular.module('nfseApp')
    .factory('GuiaSearch', function ($resource) {
        return $resource('api/_search/guias/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });
